import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {LocalCustomerFilterComponent} from '../../general-components/filter/local-customer-filter/local-customer-filter.component';
import {RegionFilterComponent} from '../../general-components/filter/region-filter/region-filter.component';
import {ResourceUnitFilterComponent} from '../../general-components/filter/resource-unit-filter/resource-unit-filter.component';
import {ServiceChangesModel} from '../../../models/ServiceChangesModel';
import {NumAnnoMeseFilterComponent} from '../../general-components/filter/num-anno-mese-filter/num-anno-mese-filter.component';
import {FormControl} from '@angular/forms';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {ServiceChangesService} from '../service/service-changes.service';
import {ContractTypeFilterComponent} from '../../general-components/filter/contract-type-filter/contract-type-filter.component';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {Sl1FilterComponent} from '../../general-components/filter/sl1-filter/sl1-filter.component';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {Offset} from 'src/models/Offset';
import {AllSettingsFilterModel} from '../../../models/AllSettingsFilterModel';
import {RegionService} from '../../general-services/service-region-anagraf/region-service.service';
import {LocalCustomerAnagrafService} from '../../general-services/service-local-customer-anagraf/local-customer-anagraf.service';
import {ContractTypeService} from '../../general-services/service-contract-type/contract-type.service';
import {Sl1AnagrafService} from '../../general-services/service-sl1-services/sl1-anagraf.service';
import {ResourceUnitService} from '../../general-services/service-resources-units-anagraf/resource-unit.service';
import {NumAnnoMeseService} from '../../general-services/service-num-anno-mese/num-anno-mese.service';

@Component({
  selector: 'app-service-changes-filter',
  templateUrl: './filter-service-changes.component.html',
  styleUrls: ['./filter-service-changes.component.scss']
})
export class FilterServiceChangesComponent  extends BaseGeneralComponent implements OnInit, OnDestroy {

  @Input() showNewEditDelete?: boolean;
  @Input() numAnnoMeseData?: any;
  @Input() filter?: ServiceChangesModel;

  localCustomerData: any;
  contractTypeData: any;
  designServiceData: any;
  resourceUnitData: any;

  @Output() dataFiltered = new EventEmitter<any>();
  @Output() resetDataFiltered = new EventEmitter<any>();

  @ViewChild(NumAnnoMeseFilterComponent, { static: true }) numAnnomeseFilterComponent;
  @ViewChild(RegionFilterComponent) regionFilterComponent;
  @ViewChild(LocalCustomerFilterComponent, { static: true }) localCustomerFilterComponent;
  @ViewChild(ContractTypeFilterComponent, { static: true }) contractTypeComponent;
  @ViewChild(Sl1FilterComponent, { static: true }) designServicesFilterComponent;
  @ViewChild(ResourceUnitFilterComponent, { static: true }) resourceUnitFilterComponent;

  filterSingle: AllSettingsFilterModel;
  labelAnnoMeseRif: string;
  offset: Offset;
  fileName: string;
  dataSource: any;

  shareNameFormControl = new FormControl();
  applicationCodFormControl = new FormControl();

  getAllSubsribe: Subscription;
  intermittentBool: boolean;

  constructor(private serviceChangesService: ServiceChangesService,
              private loaderService: LoaderService,
              private numAnnoMeseService: NumAnnoMeseService,
              private regionService: RegionService,
              private localCustomerService: LocalCustomerAnagrafService,
              private contractTypeService: ContractTypeService,
              private sl1AnagrafService: Sl1AnagrafService,
              private resourceUnitService: ResourceUnitService) {
    super();
    this.loaderService.display(true);
  }
  ngOnInit() {
    if (!this.filter) {
      this.filter = new ServiceChangesModel();
    }
    this.filterSingle = AllSettingsFilterModel.getFromServiceChangesModel(this.filter);
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    this.labelAnnoMeseRif = 'Reference Month';
    if (JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.SERVICE_CHANGES_FILTER))) {
      this.filter = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.SERVICE_CHANGES_FILTER));
      this.shareNameFormControl.setValue(this.filter.shareName);
      this.applicationCodFormControl.setValue(this.filter.applicationCod);
    }
    if (this.showNewEditDelete === undefined) {
      this.showNewEditDelete = true;
    }
    this.initFilter(this.filterSingle);
  }

  initFilter(allSettingsFilterModel: AllSettingsFilterModel, isReset?: boolean) {
    const getAllLocalCustomerObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllContractTypeObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllDesignServicesObservable: Observable<any> = this.sl1AnagrafService.getListInAllSettings(
      this.sl1AnagrafService.baseUrl,
      allSettingsFilterModel).pipe();
    const ResourceUnitObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      allSettingsFilterModel).pipe();

    forkJoin([getAllLocalCustomerObservable, getAllContractTypeObservable,
      getAllDesignServicesObservable, ResourceUnitObservable])
      .subscribe(
        (resultFork: any) => {
          this.localCustomerData = resultFork[0];
          this.contractTypeData = resultFork[1];
          this.designServiceData = resultFork[2];
          this.resourceUnitData = resultFork[3];
          if (!isReset) {
            this.loaderService.display(false);
          } else {
            this.dataFiltered.emit(this.filter);
          }
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptLocalCustomerChange(event) {
    this.loaderService.display(true);
    this.intermittentBool = true;
    this.intermittentFilterButton(this.intermittentBool);

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.localCustomer = event;
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const getAllDesignServicesObservable: Observable<any> = this.sl1AnagrafService.getListInAllSettings(
      this.sl1AnagrafService.baseUrl,
      this.filterSingle).pipe();
    const ResourceUnitObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllDesignServicesObservable);
    observableList.push(ResourceUnitObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.contractTypeData = resultFork[0];
          this.designServiceData = resultFork[1];
          this.resourceUnitData = resultFork[2];

          this.filter.contractType = this.filterSingle.contractType;
          this.filter.designServices = this.filterSingle.sl1;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptContractTypeChange(event) {
    this.loaderService.display(true);
    this.intermittentBool = true;
    this.intermittentFilterButton(this.intermittentBool);

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.contractType = event;

    /** const getAllNumAnnoMeseFilteredObservable: Observable<any> = this.numAnnoMeseService.getAllMonth(
      this.filterSingle.contractType).pipe(); **/
    const getAllLocalCustomerServicesObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllDesignServicesObservable: Observable<any> = this.sl1AnagrafService.getListInAllSettings(
      this.sl1AnagrafService.baseUrl,
      this.filterSingle).pipe();
    const ResourceUnitObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();

    // observableList.push(getAllNumAnnoMeseFilteredObservable);
    observableList.push(getAllLocalCustomerServicesObservable);
    observableList.push(getAllDesignServicesObservable);
    observableList.push(ResourceUnitObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          // this.numAnnoMeseData = resultFork[0];
          this.localCustomerData = resultFork[0];
          this.designServiceData = resultFork[1];
          this.resourceUnitData = resultFork[2];

          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.designServices = this.filterSingle.sl1;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;

          /** if (!BaseGeneralComponent.isNumAnnoMeseInFilterList(this.filter.numAnnoMese, this.numAnnoMeseData)) {
            const numAnnoMese = this.numAnnoMeseData[0] ? this.numAnnoMeseData[0] : null;
            this.filter.numAnnoMese = numAnnoMese;
          } **/

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptDesignServicesChange(event) {
    this.loaderService.display(true);
    this.intermittentBool = true;
    this.intermittentFilterButton(this.intermittentBool);

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.sl1 = event;

    const getAllLocalCustomerServicesObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeServicesObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const ResourceUnitObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllLocalCustomerServicesObservable);
    observableList.push(getAllContractTypeServicesObservable);
    observableList.push(ResourceUnitObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.localCustomerData = resultFork[0];
          this.contractTypeData = resultFork[1];
          this.resourceUnitData = resultFork[2];

          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.contractType = this.filterSingle.contractType;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptResourceUnitChange(event) {
    this.loaderService.display(true);
    this.intermittentBool = true;
    this.intermittentFilterButton(this.intermittentBool);

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.resourceUnit = event;

    const getAllLocalCustomerServicesObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeServicesObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const getAllDesignServicesObservable: Observable<any> = this.sl1AnagrafService.getListInAllSettings(
      this.sl1AnagrafService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllLocalCustomerServicesObservable);
    observableList.push(getAllContractTypeServicesObservable);
    observableList.push(getAllDesignServicesObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.localCustomerData = resultFork[0];
          this.contractTypeData = resultFork[1];
          this.designServiceData = resultFork[2];

          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.contractType = this.filterSingle.contractType;
          this.filter.designServices = this.filterSingle.sl1;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptNumAnnoMeseChange($event: any) {
    this.intermittentBool = true;
    this.intermittentFilterButton(this.intermittentBool);
  }

  filterTable(): void {
    this.loaderService.display(true);
    this.intermittentBool = false;
    this.intermittentFilterButton(this.intermittentBool);

    this.getAllFilters();

    sessionStorage.setItem(this.SESSION_STORAGE_LABELS.SERVICE_CHANGES_FILTER, JSON.stringify(this.filter));

    this.dataFiltered.emit(this.filter);
  }

  reset() {
    this.loaderService.display(true);
    this.intermittentBool = false;
    this.intermittentFilterButton(this.intermittentBool);

    const isReset = true;
    this.filter = new ServiceChangesModel();
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filterSingle = AllSettingsFilterModel.getFromServiceChangesModel(this.filter);

    this.applicationCodFormControl.setValue(this.filter.applicationCod);
    this.shareNameFormControl.setValue(this.filter.shareName);

    this.numAnnoMeseService.getAllMonth(this.filter.provider, this.filter.contractType).subscribe(
    (resultYearMonth: any) => {
      this.numAnnoMeseData = resultYearMonth;

      const providerDefault = this.filter.provider;
      this.numAnnoMeseData =  this.filterFromDxc(providerDefault, resultYearMonth);

      const numAnnoMese = this.numAnnoMeseData[0] ? this.numAnnoMeseData[0] : null;
      this.filter.numAnnoMese = numAnnoMese;

      sessionStorage.setItem(this.SESSION_STORAGE_LABELS.SERVICE_CHANGES_FILTER, JSON.stringify(this.filter));
      this.filterSingle = AllSettingsFilterModel.getFromServiceChangesModel(this.filter);

      this.initFilter(this.filterSingle, isReset);
    }, error => {
      console.log(error);
      this.loaderService.display(false);
    });
  }

  getAllFilters() {
    this.filter.numAnnoMese = this.numAnnomeseFilterComponent.optionSelected;
    this.filter.localCustomer = this.localCustomerFilterComponent.optionSelected;
    this.filter.contractType = this.contractTypeComponent.optionSelected;
    this.filter.designServices = this.designServicesFilterComponent.optionSelected;
    this.filter.resourceUnit = this.resourceUnitFilterComponent.optionSelected;
    this.filter.shareName = this.shareNameFormControl.value;
    this.filter.applicationCod = this.applicationCodFormControl.value;
  }

  ngOnDestroy(): void {
  }
}
